import {Injectable} from '@angular/core';
import {Building} from './building.model';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class BuildingService extends CrudService<Building> {
  public entityType = Building;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building.service.ts